import { Link } from "react-router-dom";
import "./footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-grid">
          <Link to="/" className="logo-link">
            <img
              src={require('../../assets/imgs/aptowebsiteslogo.png')}
              alt="Apto Websites Logo"
              className="logo"
            />
          </Link>
          <p className="logo-subtext">Helping businesses build modern websites with ready-to-use templates.</p>
          <div className="social-links">
            <Link to="https://www.instagram.com/aptowebsites/" target="_blank" rel="noopener noreferrer" aria-label="Follow Apto Websites on Instagram"><FontAwesomeIcon icon={faInstagram} className="social-link-icon" /></Link>
            <Link to="https://www.facebook.com/profile.php?id=61576929080093" target="_blank" rel="noopener noreferrer" aria-label="Follow Apto Websites on Facebook"><FontAwesomeIcon icon={faFacebook} className="social-link-icon" /></Link>
          </div>
        </div>
        <div className="footer-grid">
          <h2 className="">Explore</h2>
          <ul className="nav-items">
            <Link to='/' className="navLink">Home</Link>
            <Link to='/templates' className="navLink">Templates</Link>
            <Link to='/seo' className="navLink">SEO</Link>
            <Link to='/branding' className="navLink">Branding</Link>
            <Link to='/socials' className="navLink">Social Media</Link>
          </ul>
        </div>
        <div className="footer-grid">
          <h2 className="">Contact</h2>
          <ul className="nav-items">
            <Link to='/message' className="navLink">Contact Us</Link>
            <Link to='/privacy-policy' className="navLink">Privacy Policy</Link>
            <Link to='/terms-and-conditions' className="navLink">Terms and Conditions</Link>
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Footer;